import {
    fetchBaseQuery,
    BaseQueryFn,
    FetchArgs
} from '@reduxjs/toolkit/query/react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { FetchBaseQueryArgs } from '@reduxjs/toolkit/dist/query/fetchBaseQuery';

import { paramsSerializer } from '#adapter/convert-keys/utils';
import { convertKeysToCamel, convertKeysToSnake } from '#adapter/convert-keys/convert-keys';

/*
    Подробное описание допустимых параметров и примеров `fetchBaseQuery` можно посмотреть по ссылке.

    https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#parameters
*/
const enhancedFetchBaseQuery = (options: FetchBaseQueryArgs = {}) => fetchBaseQuery({
    ...options,
    paramsSerializer: (params) => paramsSerializer(params)
});

function prepareArgs(args: Omit<FetchArgs, 'body'> & { body?: unknown }) {
    const { body, ...restArgs } = args;
    const convertedBody = convertKeysToSnake(body);

    return {
        ...restArgs,
        body: convertedBody
    };
}

export const enhancedBaseQuery = (options?: FetchBaseQueryArgs): BaseQueryFn<
Omit<FetchArgs, 'body'> & { body?: unknown } | string,
unknown,
FetchBaseQueryError
> => async (args, api, extraOptions = {}) => {
    const preparedArgs = typeof args === 'string'
        ? args
        : prepareArgs(args);

    const result = await enhancedFetchBaseQuery(options)(
        preparedArgs,
        api,
        extraOptions
    );

    if(result.data) {
        result.data = convertKeysToCamel(result.data);
    }

    return result;
};
